var map = {
	"./airplane.png": "e34b",
	"./beers.png": "ec8b",
	"./books.png": "25f0",
	"./computer.png": "a855",
	"./eyes.png": "0853",
	"./flag-ES.png": "1cc0",
	"./flag-IT.png": "82ad",
	"./flag-UK.png": "425c",
	"./game.png": "08bc",
	"./house.png": "f760",
	"./museum.png": "e30d",
	"./music.png": "8d6c",
	"./park.png": "8ed8",
	"./photo.png": "727d",
	"./popcorn.png": "0685",
	"./shopping.png": "c4b8",
	"./sport.png": "cc95",
	"./waving-hand.png": "d05a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6efa";